








































import {
  defineComponent,
  onMounted,
  ref,
  computed
} from "@vue/composition-api";
import { useGetters, useActions } from "vuex-composition-helpers";
import NoteModel from "@/ts/models/noteClass";
import CurrentTags from "@c/molecules/current/CurrentTags.vue";
import useFetcher from "@use/useFetcher";
import MediumImage from "@c/molecules/media/MediumImage.vue";
import CurrentCaldates from "@c/molecules/current/CurrentCaldates.vue";
import PlaceChip from "@c/atoms/place/PlaceChip.vue";
import CreatedBy from "@c/atoms/app/CreatedBy.vue";

export default defineComponent({
  name: "NoteOverview",

  components: {
    CurrentTags,
    MediumImage,
    CurrentCaldates,
    PlaceChip,
    CreatedBy
  },

  setup(props, { root }) {

    const note_id = parseInt(root.$route.params.id);
    var { entity: note, loading } = useFetcher("note/GET_NOTE", {action_param:note_id});

    return {
      note,
      loading
    };
  }
});
